import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest, select } from "redux-saga/effects";
import { getUserByToken } from "../../api/auth";
import * as routerHelpers from "../../router/RouterHelpers";

export const actionTypes = {
  Login: "[Login] Action",
  Logout: "[Logout] Action",
  UserLoaded: "[Load User] Auth API",
  RequestUser: "[Request User] Action"
};

const initialAuthState = {
  user: undefined,
  authToken: undefined
};

export const reducer = persistReducer(
    { storage, key: "demo1-auth", whitelist: ["user", "authToken"] },
    (state = initialAuthState, action) => {
      switch (action.type) {
        case actionTypes.Login: {
          const { authToken } = action.payload;

          return { authToken, user: undefined };
        }

        case actionTypes.Logout: {
          routerHelpers.forgotLastLocation();
          return initialAuthState;
        }

        case actionTypes.UserLoaded: {
          const { user } = action.payload;

          return { ...state, user };
        }

        default:
          return state;
      }
    }
);

export const actions = {
  login: authToken => ({ type: actionTypes.Login, payload: { authToken } }),
  logout: () => ({ type: actionTypes.Logout }),
  fulfillUser: user => ({ type: actionTypes.UserLoaded, payload: { user } }),
  requestUser: () => ({ type: actionTypes.RequestUser })
};

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga(action) {
    const { authToken } = action.payload;
    const data = yield getUserByToken(authToken);
    yield put(actions.fulfillUser(data));
  });

  yield takeLatest(actionTypes.RequestUser, function* requestUserSaga() {
    try {
      // Get the persisted authToken from the state
      const { authToken } = yield select(state => state.auth);

      if (authToken) {
        // Fetch user data using the persisted token
        const user = yield getUserByToken(authToken);

        if (user) {
          // Successfully got user data, update the state
          yield put(actions.fulfillUser(user));
        } else {
          // Token is invalid or expired, logout
          yield put(actions.logout());
        }
      }
    } catch (error) {
      console.error("Failed to fetch user with persisted token:", error);
      // Token is invalid or expired, logout
      yield put(actions.logout());
    }
  });
}
